import CryptoJS from "crypto-js";
import JSEncrypt from "jsencrypt";

const RSA_PUBLIC_KEY = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAjlJ+0AgoueDj+7UXQaxO
vsip630/Xb8cPx3JIhbBZY1NFXuEFREHt5MeV2dF7xo7iA6iz4zqTWWCoOnecX1n
oGHu4OOTq1AKocjfH+n69pT1ufkfrTckJ0OeHyGHXZMGwdfY6KPEJXsNHDkIf5Qa
k1HI72Y+2HNFvGU2F1SPn9qtbijdKMRN0Dal3sc+UwsXqOzBHrOWAL05Kb+LjCB0
GY9cwc0rbJaLbKKTKGmEvSouPb/WUslHpR8AV3wd6fXTNg+NMkRStajHacyZMwTB
uB0FoUcwAuXvVNmUBeAHNX9/MO4o1K7tUxzrZ6YBwRvGaXl35fGUjVeaZ82gUdwl
yQIDAQAB
-----END PUBLIC KEY-----`;

function generateRandomAESKey(length = 16) {
  const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += charset.charAt(Math.floor(Math.random() * charset.length));
  }
  return result;
}

export function encryptDataHybrid(dataToEncrypt) {
  try {
    // ✅ Step 1: Create a fixed or generated 16-character key (safe for UTF-8)
    const aesKeyString = generateRandomAESKey(); // e.g., "a3Dx7F9bL0tYkQ2z"

    // ✅ Step 2: Convert to WordArray
    const rawKey = CryptoJS.enc.Utf8.parse(aesKeyString);

    // ✅ Step 3: Encrypt JSON payload
    const encrypted = CryptoJS.AES.encrypt(
      JSON.stringify(dataToEncrypt),
      rawKey,
      {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      }
    );

    const encryptedData = encrypted.toString(); // Base64

    // ✅ Step 4: Encrypt the AES key using RSA
    const rsa = new JSEncrypt();
    rsa.setPublicKey(RSA_PUBLIC_KEY);
    const encryptedKey = rsa.encrypt(aesKeyString); // Now safe

    if (!encryptedKey) throw new Error("RSA encryption failed");

    return {
      encryptedData,
      encryptedKey,
    };
  } catch (err) {
    console.error("🛑 Encryption failed:", err.message);
    return null;
  }
}

